<template>

  <div>
    <div
        class="transform flex justify-center items-center flex-col"
    >
      <div
          v-if="!player.result"
          class="w-12 h-20 shadow-inner rounded-lg filter transition transform duration-150 bg-gray-200"
      ></div>

      <div v-else>
        <vue-flip v-model="roomStateFinished" width="3rem" height="5rem">
          <template v-slot:front>
            <poker-bg
                class="w-12 h-20 rounded-lg shadow-lg filter transition transform duration-150"
                :class="{
                'grayscale-1': !!player.result,
                grayscale: !player.result,
              }"
            />
          </template>
          <template v-slot:back>
            <div
                :class="resultTier === 1 ?'border-pink-500 text-pink-500': resultTier === -1 ? 'border-green-500  text-green-500 ': 'border-blue-400  text-blue-400 ' "
                class="font-bold text-lg w-12 h-20 rounded-lg border-2  bg-white font-bold  flex items-center justify-center"
            >
              <span>{{ player.result || "NA" }}</span>
            </div>
          </template>
        </vue-flip>
      </div>
      <div
          class="flex flex-col items-center font-bold text-md text-center space-x-2 mt-2"
      >
        <div>
          <label class="text-xl font-bold"
          > {{ player.name }}</label
          >
        </div>

        <div v-if="player.photo && !player.photo.includes('avatar.png')">
          <img class="h-6" :src="player.photo" />
        </div>
        <div v-else>
          <label v-html="player.avatar" class="text-2xl block mr-1"></label>
        </div>

      </div>

      <div class="pixel"></div>

    </div>
  </div>


</template>

<style>
.flip {
  transform: rotateY(180deg);
}


</style>


<script>
import PokerBg from "../../Components/SVGs/PokerBg.vue";
import VueFlip from "vue-flip";
export default {
  props: {
    resultTier: Number,
    direction: Number,
    player: Object,
    roomStateFinished: Boolean,
    timerCount: Number,
    classes: String,
  },
  components: {
    PokerBg,
    VueFlip,
  },
  data() {
    return {
      person: {
        name: "NA",
        imageUrl: "/images/card-bg.svg",
      },
      showNumber: false,
    };
  },
};
</script>
